import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';

import { EVENTS } from '@apps/web/lib/events';

/**
 * Detect email click-through via `ref=email` search param and fire a
 * PostHog event. Strips tracking params from the URL afterward.
 * Entirely non-blocking and best-effort.
 */
export function useEmailClickTracking() {
    const posthog = usePostHog();

    useEffect(() => {
        try {
            const params = new URLSearchParams(window.location.search);
            if (params.get('ref') !== 'email') {
                return;
            }

            posthog.capture(EVENTS.EMAIL_NOTIFICATION_CLICKED, {
                email_type: params.get('email_type') ?? undefined,
                email_id: params.get('email_id') ?? undefined,
            });

            params.delete('ref');
            params.delete('email_type');
            params.delete('email_id');

            const qs = params.toString();
            const newUrl =
                window.location.pathname +
                (qs ? `?${qs}` : '') +
                window.location.hash;
            window.history.replaceState(null, '', newUrl);
        } catch {
            // Best-effort — never block the app.
        }
    }, [posthog]);
}
